import { useMemo } from 'react'
import { flattenNavItems, type PageRow } from './pageRegistry'
import { useNavItems } from 'app/hooks/useNavItems'
import { useFeatureToggleStore } from 'app/stores/StoreContext'
import type { UserJson } from 'app/types/entities'

/**
 * The palette's view of the nav tree: the Pages group, flattened through the same gates the
 * sidebar applies, plus the workspace's location count from the sidebar's own locations probe.
 * The count is undefined at org level, where there is no single workspace to count within.
 */
export function usePaletteNav(user: UserJson): { pageRows: PageRow[]; locationCount: number | undefined } {
  const { navItems, products, staffV2Enabled, locationCount } = useNavItems(user)
  const toggles = useFeatureToggleStore()
  const pageRows = useMemo(
    () =>
      flattenNavItems(navItems, {
        products,
        inWorkspace: user.workspaceId != null,
        user,
        staffV2Enabled,
        isFeatureEnabled: (name) => toggles.isEnabled(name),
      }),
    [navItems, products, staffV2Enabled, user, toggles],
  )
  return { pageRows, locationCount }
}
